import React, { useEffect, useState } from "react"
import { listenerCustomEvent } from "../../classes/eventController"
import { defPath, fetchPath } from '../../config/defPath'
import { useModal, useSession } from "../../hooks/useState"

import { useGeneralConfig } from "../../hooks/useGeneralConfig"

import Avatar from "../../views/menu";
import { page } from "../../pages/menu";

export function Logo() {
  return (
    <>
      <a className="ar_header" href="/">
        <img className="ar_header-logo" src={`${defPath}/assets/images/logo_aguila_new.png`} alt="logo aguila" />
      </a>
    </>

  )
}

export function BtnMenuProfile() {
  const { openModal, isOpen } = useModal(state => state)
  const { logged, coins, updateCoins } = useSession(state => state)
  const [points, setPoints] = useState("5")


  const getPoints = async () => {
    try {
      const res = await fetch(`${fetchPath}/aguila/loyalty/ranking`, { method: "POST" })
      const data = await res.json()
      res.ok && setPoints(data.response[0]["my_ranking"][0].points)
    } catch (error) {
      console.warn(error.message)
    }
  }

  useEffect(() => {
    listenerCustomEvent("updateCoins", (event: CustomEvent) => {
      updateCoins(parseInt(event.detail.points))
    })
  }, [])

  useEffect(() => {
    !logged && getPoints()
  }, [logged])

  const handleClickLogin = () => {
    window.location.href = "/estadio-aguila/iniciar-sesion"
    //@ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'User Login Menu',
      'interaction': 'true',
      'component_name': 'User Login Menu',
      'element_text': 'Menú',
    });
  }

  const handleClickRegister = () => {
    window.location.href = "/estadio-aguila/registro"
    //@ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'User Register Menu',
      'interaction': 'true',
      'component_name': 'User Register Menu',
      'element_text': 'Menú',
    });
  }

  return (
    <>
      {!logged ?
        <div className={`ar_header ${isOpen ? "close" : ""}`} >
          <div className="ar_header_avatar">
            <img src={`${defPath}/assets/images/bg_avatar.png`} alt="fondo avatar" />
          </div>
          <button className="ar_header_login" onClick={handleClickLogin}>
            <div className="ar_header_login--text">
              Iniciar<br />
              Sesión
            </div>
          </button>
          <button className="ar_header_register" onClick={handleClickRegister}>
            <div className="ar_header_register--text whiteShadow">
              Registro
            </div>
          </button>

        </div>
        :
        <div className={`ar_header ${isOpen ? "close" : ""}`} >
          <div className="ar_header_avatar">
            <img src={`${defPath}/assets/images/bg_avatar.png`} alt="fondo avatar" />
          </div>
          <button className="ar_header_points">
            <div className="ar_header_points--text">
              puntos<br />
              <span id="ar__points">{points}</span>
            </div>
          </button>
          <button className="ar_header_coins">
            <div className="ar_header_coins--text whiteShadow">
              <img src={`${defPath}/assets/images/icons/coins.png`} alt="icono menu" />
              <span id="ar__coins">{coins}</span>
            </div>
          </button>

        </div>


      }




      {/* <div className={`ar_header ${isOpen ? "close" : ""}`} >

                <button className="ar_header_user glow" onClick={handleClick}>
                    {
                        logged 
                            ? <Coins />
                            :   
                            <div className="ar_header_user--text black_30 whiteShadow">
                                <span className="small">login o</span><br />
                                registro
                            </div>
                    }
                    <img src={`${defPath}/assets/images/icons/icon_menu.svg`} alt="icono menu" />
                    </button>
                    
                </div> */}
    </>

  )
}

export function BtnMenu() {
  const { openModal } = useModal(state => state)

  const handleClick = () => {
    openModal('menu_profile')
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Card',
      'event_label': 'Career Mode',
      'interaction': 'true',
      'component_name': 'Career Mode',
      'element_text': 'Modo Carrera',
    });
  }
  return (
    <>
      <button className="ar_layout-menu" onClick={handleClick} >
        <img className="ar_layout-menu-img" src={`${defPath}/assets/images/btn_ball.png`} alt="logo menu carrera" />
        <div className="ar_layout-menu-btn black_30">
          <img className="ar_layout-menu-btn-img" src={`${defPath}/assets/images/icons/icon_menu.svg`} alt="icono menu" />
          <span className="shadowWhite">Menú</span>
        </div>
      </button>
    </>
  )
}

export function MenuProfile() {
  const { closeModal } = useModal(state => state)
  const { logged, user, closeSession } = useSession(state => state)

  const menuItems = useGeneralConfig(state => state.menu)

  const logout = () => {
    // sendDatalayerMenu('Cerrar sesión')
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Principal Menu Close Session',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_PrincipalMenu',
      'element_text': 'Cerrar sesión',
    });
    closeSession()
  }

  const sendDatalayerMenu = (value: string) => {
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': `${value} - Principal Menu`,
      'interaction': 'true',
      'component_name': 'Modo_Carrera_PrincipalMenu',
      'element_text': `${value}`,
    });
  }

  const handdleClose = () => {
    closeModal()

    if (logged) {
      // @ts-ignore
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': 'Close User Zone Menu',
        'interaction': 'true',
        'component_name': 'User Zone Menu',
        'element_text': 'Menu',
      });
    }

    else {
      // @ts-ignore
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Button',
        'event_label': 'Close Principal Menu',
        'interaction': 'true',
        'component_name': 'Principal Menu',
        'element_text': 'Menu Principal',
      });
    }
  }

  useEffect(() => {
    // page()
    window.matchMedia("(min-width: 991px)").matches && page()
  }, [])

  return (
    <>
      <div className={`ar__menu_profile ${logged && 'logged'}`}>
        <div className="ar__menu_profile_container">
          {
            window.matchMedia("(min-width: 991px)").matches ? <Avatar /> : (
              <div className="ar__menu_avatar">
                <img className="ar__menu_avatar--image" src={`${defPath}/assets/images/menu/avatar_menu.png`} alt="image avatar" />
              </div>
            )
          }
          <ul className={`ar__menu_profile--list`}>

            {Object.values(menuItems).map((item, key) => {
              const text = item.name.replace(/(<([^>]+)>)/gi, "");
              return <a key={key} href={item.url} className={`ar__menu_profile--link title_2 brushText_white-left-block`} onClick={() => sendDatalayerMenu(text)}>
                <p className="ar__menu_profile--label" dangerouslySetInnerHTML={{ __html: item.name.replace(/(<\/?p>)/gi, "") }}></p>
                <div className="ar__menu_profile--icon">
                  <img src={item.icon} alt={`icono ${text}`} />
                </div>
              </a>
            })}

          </ul>

          {logged && <button className={`ar__btn_close_session title_2`} onClick={logout}>
            <div className="ar__btn_close_session--label">cerrar sesión</div>
            <div className="ar__btn_close_session--icon">
              <img src={`${defPath}/assets/images/icons/icon_close_session.svg`} alt="icono close session" />
            </div>
          </button>}

        </div>

        {!logged && <AlertRegister />}

      </div>
    </>

  )
}

export function AlertRegister() {
  const { closeModal, isOpen } = useModal(state => state)

  isOpen && window.dataLayer.push({
    'event': 'GAEvent',
    'event_category': 'Content',
    'event_action': 'Content',
    'event_label': 'Register Unregistered user',
    'interaction': 'true',
    'component_name': 'Modo_Carrera_PopUp_Registrate',
    'element_text': 'Regístrate y sé un hincha oficial',
  });

  const handleClick = (e: any) => {
    // @ts-ignore
    window.dataLayer.push({
      'event': 'GAEvent',
      'event_category': 'Content',
      'event_action': 'Button',
      'event_label': 'Register Unregistered user',
      'interaction': 'true',
      'component_name': 'Modo_Carrera_PopUp_Registrate',
      'element_text': e.target.textContent,
    });

    window.location.href = "/estadio-aguila/registro"
  }
  return (
    <div className="ar__alert_register">
      <div className="ar__alert_register--star"></div>
      <div className="ar__alert_register__body">
        <div className="logo logo-olas">
          <img src={`${defPath}/assets/images/newHeaderTopLogos/olas.png`} alt="Logo Olas" />
        </div>
        <a href="/estadio-aguila" className="logo logo-modal">
          <img src={`${defPath}/assets/images/logo_aguila_new.png`} alt="Logo Aguila" />
        </a>
        <p className="ar__alert_register--title title_2">
          Regístrate <br /> <span className="small">y sé un hincha oficial</span>
        </p>
        <p className="ar__alert_register--text">
          Desbloquea el estadio entero, personaliza tu avatar, reclama puntos y muchas características más registrándote.
        </p>
        <button className="newBottom--smallYellow" onClick={handleClick}>
          {window.matchMedia("(min-width: 991px)").matches
            ? 'Haz clic aquí'
            : 'Toca aquí'}
        </button>
      </div>
    </div>
  )
}


